import levelsToFilter from './levelsToFilter';
import statusesToFilter from './statusesToFilter';

export default [
    {
        id: 0,
        value: {
            description: 'status',
            type: 'text',
            id: 1,
            data: statusesToFilter,
            isIndexed: true,
            operator: 'equal',
            label: 'status'
        },
        label: 'Estado'
    },
    {
        id: 1,
        value: {
            description: 'id_level',
            type: 'select',
            id: 1,
            data: levelsToFilter,
            isIndexed: true,
            operator: 'equal',
            label: 'level'
        },
        label: 'Nivel'
    }

];
